import type { ResourcesContext } from '../resources/resourcesContext';

export type GarmentRenderable = { garmentGeometryRef?: string };

/**
 * Create garment renderable.
 * @param id - Seam ID.
 * @param parent - Seam object.
 */
export const create = (): GarmentRenderable => {
  return {};
};

/**
 * Dispose Garment renderable.
 * @param self - Garment renderable.
 * @param resources - Resources manager.
 */
export const dispose = (self: GarmentRenderable, resources: ResourcesContext) => {
  detachGarmentGeometry(self, resources);
};

/**
 * Attach garment geometry.
 * @param self - Garment renderable.
 * @param garmentGeometryId - Garment geometry ID.
 * @param resources - Resources context.
 */
export const attachGarmentGeometry = (
  self: GarmentRenderable,
  garmentGeometryId: string,
  resources: ResourcesContext,
) => {
  if (self.garmentGeometryRef) {
    detachGarmentGeometry(self, resources);
  }
  resources.getRefGarmentGeometry(garmentGeometryId);
  self.garmentGeometryRef = garmentGeometryId;
};

/**
 * Detach garment geometry.
 * @param self - Garment renderable.
 * @param resources - Resources context;
 */
export const detachGarmentGeometry = (self: GarmentRenderable, resources: ResourcesContext) => {
  if (!self.garmentGeometryRef) {
    return;
  }
  resources.retRefGarmentGeometry(self.garmentGeometryRef);
  delete self.garmentGeometryRef;
};
